import { render, staticRenderFns } from "./ActivatePromocode.vue?vue&type=template&id=e0b51030&scoped=true&"
import script from "./ActivatePromocode.vue?vue&type=script&lang=js&"
export * from "./ActivatePromocode.vue?vue&type=script&lang=js&"
import style0 from "./ActivatePromocode.vue?vue&type=style&index=0&id=e0b51030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b51030",
  null
  
)

export default component.exports